module.exports = __webpack_public_path__ + "static/6-4cb448fc8f5164cd9c97b7166d42c9b8.jpg";